/* eslint-disable import/no-extraneous-dependencies */
import React, { useEffect, useRef, useState } from "react";
import { FormattedMessage } from "react-intl";
import { gsap } from "gsap";

import ConfettiAnimation from "@components/conffeti-animation/confetti-animation";
import HtmlSpan from "@components/html-span/HtmlSpan";
import MsStarkyPaymentSvg from "@components/icons/ms-starky-payment-svg";
import MsStarkySvg from "@components/icons/ms-starky-svg";
import KeysAnimation from "@components/keys-animation/keys-animation";

import { useMediaQuery } from "@hooks/use-media-query";
import { formatUrlWithLocale } from "@helpers/format-url-with-locale";

type PropsType = {
  closeCourse: () => void;
  courseTitle: string;
  courseName: string;
  courseLanguage: string;
  certPrice: string;
  hasCourseCert: string;
  typingTestUrl: string;
};

export function CourseComplete({
  closeCourse,
  courseTitle,
  courseName,
  courseLanguage,
  certPrice,
  hasCourseCert,
  typingTestUrl,
}: PropsType) {
  const isLargeScreen = useMediaQuery({ minWidth: 768 });
  const btn = useRef<HTMLAnchorElement>(null);
  const handleKeyDown = (event: React.KeyboardEvent<HTMLAnchorElement>) => {
    if (event.keyCode === 32 || event.keyCode === 13) {
      event.currentTarget.click();
    }
  };
  const onDonateClickHandler = () => {
    document.cookie = `eventCategory=Donate_link_course; path=/;`;
  };
  const coverText = (word: any) => (
    <a
      id='Donate_link_course'
      href={formatUrlWithLocale("/donation/")}
      onClick={onDonateClickHandler}
    >
      {word}
    </a>
  );
  useEffect(() => {
    window.scrollBy(0, 130);
    btn.current?.focus();
  }, []);

  const starkyRef = useRef(null);
  const certificateRef = useRef(null);

  useEffect(() => {
    gsap.to(certificateRef.current, {
      duration: 2,
      opacity: 1,
      rotate: 720,
      scale: 1,
      ease: "power2.inOut",
    });
  }, []);

  useEffect(() => {
    gsap.to(starkyRef.current, {
      x: 0,
      duration: 1.6,
      opacity: 1,
      rotate: 0,
      delay: 0.5,
      ease: "elastic.out(1, 0.8)",
    });
  }, []);

  return (
    <section className='mx-auto mb-6 max-w-container-xsmall text-center md:mb-8'>
      <MsStarkySvg
        ref={starkyRef}
        width={100}
        height={100}
        classNameProps='mx-auto mb-4 translate-x-[200px] rotate-180 opacity-0 will-change-transform'
      />
      <h2>
        <FormattedMessage id='congrats' />
      </h2>
      <p>
        <FormattedMessage
          id='сourse-complete-title'
          values={{
            courseTitle,
          }}
        />
      </p>
      <div className='relative'>
        {hasCourseCert ? (
          <a
            href={formatUrlWithLocale(
              `/u${window.apiUserId}/course-certificate/${courseName}/`,
            )}
            className='not-prose'
          >
            <img
              ref={certificateRef}
              className='mx-auto mb-3 scale-0 opacity-0 will-change-transform md:mb-4'
              width={480}
              height={336}
              src={hasCourseCert}
              alt='cert'
            />
          </a>
        ) : (
          <a
            href={formatUrlWithLocale(
              `/u${window.apiUserId}/course-certificate/purchase/${courseName}/`,
            )}
            className='not-prose'
          >
            <img
              ref={certificateRef}
              className='mx-auto mb-3 scale-0 opacity-0 will-change-transform md:mb-4'
              width={480}
              height={336}
              src={
                isLargeScreen
                  ? `/static/img/certificate/empty/certificate-course_${courseLanguage}.png`
                  : `/static/img/certificate/certificate-course_${courseLanguage}.png`
              }
              alt='cert'
            />
          </a>
        )}
        {isLargeScreen && (
          <KeysAnimation shouldAnimateAppearKeys={!!hasCourseCert} />
        )}
      </div>
      <div className='mb-4 md:mb-5'>
        {hasCourseCert ? (
          <a
            className='btn btn-primary'
            onKeyDown={handleKeyDown}
            href={typingTestUrl}
            ref={btn}
            type='button'
          >
            <FormattedMessage id='test-your-speed' />
          </a>
        ) : (
          <a
            id='CourseCert_tutorCourseComplete'
            className='btn btn-primary'
            onClick={(e) => {
              document.cookie = `eventCategory=${e.currentTarget.id};path=/`;
            }}
            onKeyDown={handleKeyDown}
            href={formatUrlWithLocale(
              `/u${window.apiUserId}/course-certificate/purchase/${courseName}/`,
            )}
            ref={btn}
            type='button'
          >
            <FormattedMessage
              id='get-paid-certificate'
              values={{ price: <HtmlSpan html={certPrice} /> }}
            />
          </a>
        )}
      </div>
      <hr className='dark:border-brd-dark-primary mb-4 border-t-2 border-brd-primary' />
      {/* <p>
        <FormattedMessage
          id='support-us'
          values={{
            code: (word) => coverText(word),
          }}
        />
      </p> */}
    </section>
  );
}

export default CourseComplete;
